import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { take } from 'rxjs/operators';
import { AuthService } from 'src/app/auth-section/auth-service/auth.service';
import { DoctorsService } from 'src/app/shared/doctor-service/doctors.service';
@Component({
  selector: 'app-emergency',
  templateUrl: './emergency.component.html',
  styleUrls: ['./emergency.component.css']
})
export class EmergencyComponent implements OnInit {
  moment:any=moment;
  id:any;
  token:any;
  clinicArray:any;
  clinicData:any;
  date4: Date = null;
  appArray:any;
  
  constructor(private appt:AuthService,private docservice:DoctorsService,private auth:AuthService) { }

  ngOnInit(): void {
    this.auth.authDataSubject.pipe(take(1)).subscribe((auth:any) => {
      this.token = auth.token;
      this.id = auth.id;
      console.log("authData",auth)
    });
    this.date4 = new Date();
    this.gelAllClinic();
  }
  
  Emergencyappointment(){
    this.appt.Emergencyappt(this.clinicData._id,this.date4,this.token).subscribe((res:any)=>{
      console.log("this is console ",res);
      this.appArray = res.data.docs;
    })
  }

  doSomething() {
    this.Emergencyappointment();
    console.log(this.date4);
  }

  onChangeClinic(index) {
    this.clinicData = this.clinicArray[index];
    this.Emergencyappointment();
  }

  gelAllClinic() {
    this.docservice.getAllClinic(this.id, this.token).subscribe((res) => {
      console.log("getallclinic",res);
      this.clinicArray = res.clinics;
      this.clinicData = this.clinicArray[0];
      this.Emergencyappointment();
    });
  }

}